import React from "react";
import { HeadingBox, Count, Title, Subtitle } from "./templateStyle";

function Heading({ data = {} }) {
  const { title, subtitle, count } = data;
  return (
    <HeadingBox>
      {count && <Count variant="label1">{count}</Count>}
      {title && <Title variant="heading5">{title}</Title>}
      {subtitle && <Subtitle variant="paragraph2">{subtitle}</Subtitle>}
    </HeadingBox>
  );
}

export default Heading;
